import { render, staticRenderFns } from "./SetEmail.vue?vue&type=template&id=672b8ba4&scoped=true&"
import script from "./SetEmail.vue?vue&type=script&lang=js&"
export * from "./SetEmail.vue?vue&type=script&lang=js&"
import style0 from "./SetEmail.vue?vue&type=style&index=0&id=672b8ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b8ba4",
  null
  
)

export default component.exports